export default {
  methods: {
    searchBy (data, filterString, propsToFilterWith) {
      if (!filterString) {
        return data
      }

      let filteredData = []
      let SEARCHABLE_TYPES = ['string', 'number', 'boolean', 'date']

      window._.each(data, record => {
        for (let i = 0; i < propsToFilterWith.length; ++i) {
          let prop = propsToFilterWith[i]

          if (!prop.useInFilter) {
            continue
          }

          let normalisedRecord = this.getDefaults(window._.cloneDeep(record), prop.defaults, prop.useDefault)
          let value = normalisedRecord[prop.name]
          if (prop.type === 'date') {
            value = normalisedRecord[prop.name]
          }

          if (SEARCHABLE_TYPES.indexOf(typeof (value)) < 0) {
            continue
          }

          let normalised = value.toString().toLowerCase()

          if (prop.positionSensitivity && normalised.indexOf(filterString.toLowerCase()) === 0) {
            filteredData.push(record)
            break
          }

          if (!prop.positionSensitivity && normalised.indexOf(filterString.toLowerCase()) > -1) {
            filteredData.push(record)
            break
          }
        }
      })

      return filteredData
    },
    getDefaults (record, defaults, useDefault) {
      if (!useDefault) return record
      window._.each(defaults, propDefault => {
        record = window._.defaults(record, record[propDefault])
      })
      return record
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/search.js